import { NavLink, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { LayoutDashboard, Search, CalendarCheck, CalendarClock, Heart, User, LogOut, Home, MessageSquare } from "lucide-react";
import apiClient from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const navItems = [
  { to: "/customer", label: "Dashboard", icon: LayoutDashboard, end: true, testid: "customer-nav-dashboard" },
  { to: "/search", label: "Cari Hunian", icon: Search, testid: "customer-nav-search" },
  { to: "/customer/messages", label: "Pesan", icon: MessageSquare, testid: "customer-nav-messages", badge: true },
  { to: "/customer/bookings", label: "Booking Saya", icon: CalendarCheck, testid: "customer-nav-bookings" },
  { to: "/customer/surveys", label: "Survei Saya", icon: CalendarClock, testid: "customer-nav-surveys" },
  { to: "/customer/favorites", label: "Favorit Saya", icon: Heart, testid: "customer-nav-favorites" },
  { to: "/customer/profile", label: "Profil", icon: User, testid: "customer-nav-profile" },
];

export default function CustomerLayout({ children, testid = "customer-shell" }) {
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const [unread, setUnread] = useState(0);

  useEffect(() => {
    const load = () => apiClient.get("/conversations/unread-count").then((r) => setUnread(r.data?.unread || 0)).catch(() => {});
    load();
    const t = setInterval(load, 20000);
    return () => clearInterval(t);
  }, []);

  const handleLogout = async () => {
    await logout();
    navigate("/");
  };

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10" data-testid={testid}>
      <div className="flex flex-col lg:flex-row gap-8">
        <aside className="lg:w-64 shrink-0">
          <div className="bg-card border border-border rounded-2xl p-4 lg:sticky lg:top-24">
            <div className="flex items-center gap-2 px-2 pb-4 mb-2 border-b border-border">
              <span className="grid place-items-center w-8 h-8 rounded-lg bg-primary text-primary-foreground">
                <Home size={16} />
              </span>
              <div className="min-w-0">
                <p className="font-heading text-sm font-semibold leading-tight truncate" data-testid="customer-sidebar-name">
                  {user?.name || "Customer"}
                </p>
                <p className="text-xs text-muted-foreground">Customer</p>
              </div>
            </div>
            <nav className="space-y-1">
              {navItems.map((item) => (
                <NavLink
                  key={item.to}
                  to={item.to}
                  end={item.end}
                  data-testid={item.testid}
                  className={({ isActive }) =>
                    `flex items-center gap-2.5 px-3 py-2.5 rounded-xl text-sm font-medium transition-colors ${
                      isActive ? "bg-secondary text-primary" : "text-muted-foreground hover:bg-secondary/60"
                    }`
                  }
                >
                  <item.icon size={16} /> <span className="flex-1">{item.label}</span>
                  {item.badge && unread > 0 && (
                    <span className="text-[10px] font-bold px-2 py-0.5 rounded-full bg-accent text-accent-foreground" data-testid="customer-messages-badge">{unread}</span>
                  )}
                </NavLink>
              ))}
              <button
                onClick={handleLogout}
                data-testid="customer-nav-logout"
                className="w-full flex items-center gap-2.5 px-3 py-2.5 rounded-xl text-sm font-medium text-muted-foreground hover:bg-secondary/60 transition-colors"
              >
                <LogOut size={16} /> Keluar
              </button>
            </nav>
          </div>
        </aside>

        <div className="flex-1 min-w-0">{children}</div>
      </div>
    </div>
  );
}
